// extracted by mini-css-extract-plugin
export default {"video_container":"Home_video_container__1dtb1","TopTalent_outer_Container":"Home_TopTalent_outer_Container__3I50s"};